import {InjectionToken} from "@angular/core";

export const CONTACT_DETAILS = new InjectionToken<ContactDetails>("CONTACT_DETAILS")

export interface ContactDetails {
  phoneNumber: string;
  email: string;
  address: string;
}
